import { render, staticRenderFns } from "./newscreen.vue?vue&type=template&id=d754380e&"
import script from "./newscreen.vue?vue&type=script&lang=js&"
export * from "./newscreen.vue?vue&type=script&lang=js&"
import style0 from "./newscreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports